import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes with proper handling of conflicting styles.
 * Combines clsx for conditional class names and tailwind-merge for resolving Tailwind conflicts.
 *
 * @param inputs - Array of class values (strings, objects, arrays, etc.)
 * @returns Merged and deduplicated className string
 *
 * @example
 * ```ts
 * cn('px-2 py-1', condition && 'bg-blue-500', { 'text-white': isActive })
 * // Returns: "px-2 py-1 bg-blue-500 text-white" (if condition and isActive are true)
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
